
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Site Internet professionnel : comment bien choisir son nom de domaine ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Cet article vous donne les clés pour obtenir un nom de domaine unique et éviter les erreurs qui peuvent coûter cher.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Site Internet professionnel : comment bien choisir son nom de domaine ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous donne les clés pour obtenir un nom de domaine unique et éviter les erreurs qui peuvent coûter cher.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
